import { useState } from 'react';
import { uploadImage } from 'helpers/menuManagement';
import { UploadImageResponse } from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';
import { EditDrawerFormType, HandleImageUploadParams, HandleImageUploadFunction } from '../types';

export interface UseImageHandlersParams {
  form: EditDrawerFormType;
  setUploadImageFile: (file: File | null) => void;
}

export interface UseImageHandlersReturn {
  isUploading: boolean;
  handleRemoveImage: () => void;
  handleImageUpload: HandleImageUploadFunction;
}

function isValidUploadResponse(response: unknown): response is UploadImageResponse {
  return (
    typeof response === 'object' &&
    response !== null &&
    (!('file' in response) ||
      response.file === undefined ||
      (typeof response.file === 'object' &&
        response.file !== null &&
        typeof (response.file as { url?: unknown }).url === 'string'))
  );
}

export function useImageHandlers({
  form,
  setUploadImageFile,
}: UseImageHandlersParams): UseImageHandlersReturn {
  const [isUploading, setIsUploading] = useState(false);

  const handleRemoveImage = (): void => {
    setUploadImageFile(null);
    form.setValues({
      ...form.values,
      imageUrl: '',
      uploadImageFile: null,
    });
  };

  const handleImageUpload = async ({
    companyId,
    itemType,
    uploadImageFile,
  }: HandleImageUploadParams): Promise<string> => {
    setIsUploading(true);
    try {
      const response = await uploadImage({
        companyId,
        itemType,
        uploadImageFile,
      });

      if (isValidUploadResponse(response)) {
        return response?.file?.url || '';
      }

      return '';
    } finally {
      setIsUploading(false);
    }
  };

  return {
    isUploading,
    handleRemoveImage,
    handleImageUpload,
  };
}
